module.exports = "images/doc-client-menu.900979d5924488f31f95945626eb7b2b.png";